import { createRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("rubricator_app");
if (container) {
	const root = createRoot(container);
	root.render(<App />);
}
